export default __webpack_public_path__ + "static/media/example_img_1_6.35d0288f.png";